import React, { useEffect, useState } from 'react';
import './detail.scss';
import { useParams, useSearchParams } from 'react-router-dom';
import moment from 'moment';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { faLocationDot, faPencil, faPercentage } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import HotelDetailLoader from '../../../components/hotel/HotelDetailLoader';
import HotelHeaderImage from '../../../components/hotel/HotelHeaderImage';
import Map from '../../../components/common/Maps';
import HotelAmenity from '../../../components/hotel/HotelAmenity';
import RoomDateChanger from '../../../components/hotel/RoomDateChanger';
import HotelRatings from '../../../components/hotel/HotelRatings';
import useHotelDetail from '../../../state/hotel-detail/hooks/useProducer';
import useBookingData from '../../../state/booking/hooks/useProducer';
import RoomListCard from '../../../components/hotel/RoomListCard';
import { renderHTML } from '../../../helper/encodeHtml';
import useRoomRate from '../../../state/room-rate/hooks/useProducer';
import '../../../static/css/style.scss';

export default function HotelDetailPage() {
  const [hotel, setHotelDetail] = useHotelDetail();
  const { initialData } = useBookingData();
  const { hotelId } = useParams();
  const { roomRate } = useRoomRate();

  useEffect(() => {
    if (!hotel.detail || hotel.detail.length === 0) {
      // eslint-disable-next-line func-names
      (async function () {
        await setHotelDetail(hotelId);
      })();
      initialData();
    }
  }, []);

  const [guestCount, setGuestCount] = useState({});
  const [bookDate, setBookDate] = useState({});
  const [searchParams] = useSearchParams();
  const [showDeal, setShowDeal] = useState(false);

  const [roomDateModal, setRoomDateModal] = useState(false);

  const roomDateModalShow = () => setRoomDateModal(true);
  const roomDateModalClose = () => setRoomDateModal(false);

  let guest = 0;
  useEffect(() => {
    try {
      guest += searchParams.has('children') ? +searchParams.get('children') : 0;
      guest += searchParams.has('adults') ? +searchParams.get('adults') : 0;
      setGuestCount(guest);

      setBookDate({
        checkIn: searchParams.get('check_in'),
        checkOut: searchParams.get('check_out'),
        text: `${moment(searchParams.get('check_in'), 'MM/DD/YYYY').format('ll')} - ${moment(searchParams.get('check_out'), 'MM/DD/YYYY').format('ll')}`,
      });
      // setSearchParams(searchParams);
    } catch (error) {
      console.log('error', error);
    }
  }, []);

  useEffect(() => {
    const pricePercent = _.find(roomRate.rooms, (r) => {
      return r.rate_data.benchmark_price_details.saving_percentage > 0;
    });
    if (pricePercent) {
      setShowDeal(true);
    } else {
      setShowDeal(false);
    }
  }, [roomRate]);

  useEffect(() => {
    setBookDate({
      checkIn: searchParams.get('check_in'),
      checkOut: searchParams.get('check_out'),
      text: `${moment(searchParams.get('check_in'), 'MM/DD/YYYY').format('ll')} - ${moment(searchParams.get('check_out'), 'MM/DD/YYYY').format('ll')}`,
    });
    guest = 0;
    guest += searchParams.has('children') ? +searchParams.get('children') : 0;
    guest += searchParams.has('adults') ? +searchParams.get('adults') : 0;
    setGuestCount(guest);
  }, [searchParams]);

  if (hotel.isLoading) {
    return <HotelDetailLoader />;
  }

  return (
    <>
      <HotelHeaderImage photoList={hotel.detail.photo_data} />
      <Container fluid="lg" className="mt-5 px-md-10 px-sm-2">
        <Row>
          <Col md={6}>
            <Row>
              <Col md={12}>
                <h1 className="text-light">{hotel.detail.name}</h1>
                <hr />
                <h2>Hotel Description</h2>
                <span>{renderHTML(hotel.detail.hotel_description)}</span>
              </Col>
              <Col md={12} className="mt-5 gy-2">
                <h3>Available Rooms</h3>
                {showDeal && (
                  <Card body className="discount-card">
                    Select Member Deals Applied!
                    <FontAwesomeIcon icon={faPercentage} className="select-color fa-pull-right card-icon" />
                  </Card>
                )}

                <RoomDateChanger show={roomDateModal} close={() => roomDateModalClose()} />
                <Card body className="pointer my-2 bg-transparent border-dark" onClick={() => roomDateModalShow()}>
                  <Row>
                    <Col sm={10}>
                      <Row>
                        <span>{bookDate.text}</span>
                        <span>
                          {searchParams.get('rooms')} Room, {guestCount} Guest
                        </span>
                      </Row>
                    </Col>
                    <Col sm={2} className="d-flex align-items-center justify-content-end">
                      <FontAwesomeIcon icon={faPencil} className="select-color card-icon fa-pull-right" />
                    </Col>
                  </Row>
                </Card>
                <RoomListCard />
              </Col>
            </Row>
          </Col>
          <Col md={6} className="px-10">
            <Row>
              <Map geo={hotel.detail.geo} />
            </Row>
            <Row className="mt-5 border-bottom pb-3">
              <Col md="1">
                <FontAwesomeIcon icon={faLocationDot} className="select-color" size="1x" />
              </Col>
              <Col md={11}>
                Address
                <span>{hotel.detail.address.one_line}</span>
              </Col>
            </Row>
            <HotelAmenity amenities={hotel.detail.amenity_data} />
            {hotel.detail.review_count > 0 && <HotelRatings rating={hotel.detail.review_rating} hotelId={hotel.detail.id} ratingCount={hotel.detail.review_count} ratingDescription={hotel.detail.review_rating_desc} />}
          </Col>
        </Row>
      </Container>
    </>
  );
}
